import styled, { css } from 'styled-components';
import { mq, getSpace, getGridSpan, getGridSpans, px2rem } from '../../../stylesheets/tools';

const transitionDots = '/static/dots/footer-background.svg';

const StyledFullscreenMedia = styled.div`
  position: relative;
  margin: ${getSpace('xxl')} 0;

  .media__media-section {
    .container__wrapper {
      margin: 0;
    }
    .media__wrapper {
      width: 100%;
      margin-bottom: ${getSpace('35px')};
      position: relative;
      animation: loadingBg 1.5s linear infinite alternate;
      display: inline-block;

      ${props =>
        props.hasBackground &&
        props.hasHeadline === '' &&
        css`
          margin: 160px 0 40px 0;
        `}

      ${props =>
        props.hasHeadline !== '' &&
        css`
          margin: 180px 0 40px 0;
        `}

      ${props =>
        props.type === 'embeddedVideo' &&
        css`
          margin: 0 0 40px 0;
        `}

      ${props =>
        props.type !== 'embeddedVideo' &&
        props.hasBackground &&
        css`
          &:before {
            z-index: -1;
            content: '';
            right: 0;
            position: absolute;
            width: 95%;
            top: -150px;
            height: 218px;
            background-color: ${props.theme.siteTheme.secondary};
            mask-image: url(${transitionDots});
            mask-size: 296px 218px;
            mask-repeat: repeat;
          }
          &:after {
            z-index: -1;
            content: '';
            right: 0;
            position: absolute;
            width: 95%;
            height: 40px;
            bottom: -40px;
            background-color: ${props.theme.siteTheme.secondary};
          }
        `}

      img {
        aspect-ratio: 16 / 9;
        width: 100%;
        object-fit: cover;
      }
    }
  }


  .media__content-section {
    max-width: 83.75rem;
    margin-left: auto;
    margin-right: auto;

    &.with--spacing {
      padding: ${px2rem('40px')} 0 ${px2rem('20px')} 0;

      ${mq('l')} {
        padding: ${px2rem('120px')} 0 ${px2rem('20px')} 0;
      }
    }

    .media__content {
      display: flex;
      position: relative;

      .media__content-container {
        .container__wrapper {
          position: unset;
        }

        .media__content-intro {
          display: flex;
          gap: 10px;
          margin-bottom: ${getSpace('m')};
          flex-direction: column-reverse;

          ${mq('l')} {
            gap: 80px;
            margin-bottom: ${getSpace('l')};
            flex-direction: row;
          }

          .media__content-headlines {
            ${getGridSpans('width', { s: 12, l: 7 })}

            h3 {
              margin-bottom: ${getSpace('s')};
            }
          }
          .media__content-hints {
            margin-left: auto;
            margin-bottom: ${getSpace('s')};
            ${getGridSpans('width', { s: 12, l: 5 })}

            .media__content-credits {
              ${mq('xl')} {
                margin: 0;
                width: ${px2rem('360px')};
                position: absolute;
                right: 100%;
                top: 0px;
                transform-origin: top right;
                transform: rotate(-90deg);
              }
            }
          }
        }
        .media__content-copy {
          ${mq('l')} {
            margin-left: ${getGridSpan(1, 'spread')};
            ${getGridSpans('width', { m: 10 })}
          }
        }
      }
    }
  }


  .media__credits {
    position: relative;
    margin: 0;
    padding-top: 20px;
    ${getGridSpans('margin-left', { m: [2, 'spread'], l: [8, 'spread'] })}
    ${getGridSpans('width', { s: 12, m: 8, l: 4 })}

    ${mq('xl')} {
      margin-top: 20px;
      padding-top: 0px;
    }
  }

  .media__caption {
    position: relative;
    margin: 0;
    ${getGridSpans('width', { s: 12, m: 8, l: 4 })}
    ${getGridSpans('margin-left', { m: [2, 'spread'], l: [8, 'spread'] })}
    padding-top: 20px;

    ${mq('xl')} {
      margin-top: 60px;
      padding-top: 0px;
    }
  }
  ${props =>
    props.insideContainer === true &&
    props.alignment === 'left' &&
    css`
      .media__wrapper {
        right: 20px;

        ${mq('m')} {
          right: 30px;
        }

        ${mq('xl')} {
          right: 60px;
        }

        ${mq('xl')} {
          right: ${getGridSpan('1', 'spread')};
        }
      }

      .media__background {
        left: ${getGridSpan('1', 'spread')};

        ${mq('xl')} {
          left: 0;
        }
      }

      .media__credits {
        ${mq('xl')} {
          right: ${getGridSpan(1)};
          transform-origin: top right;
          top: 80px;
        }
      }
    `}
  ${props =>
    props.insideContainer === true &&
    props.alignment === 'right' &&
    props.type !== 'introVideo' &&
    css`
      .media__wrapper {
        left: 20px;

        ${mq('m')} {
          left: 30px;
        }

        ${mq('xl')} {
          left: 60px;
        }

        ${mq('xl')} {
          left: ${getGridSpan('1', 'spread')};
        }
      }

      .media__background {
        right: ${getGridSpan('1', 'spread')};

        ${mq('xl')} {
          right: 0;
        }
      }

      .media__credits {
        ${mq('xl')} {
          left: ${getGridSpan(1)};
          transform-origin: bottom left;
          bottom: 80px;
        }
      }
    `}
  ${props =>
    props.type === 'introVideo' &&
    css`
      .media__background {
        right: ${getGridSpan('1', 'spread')};
        margin-right: 20px;

        ${mq('m')} {
          margin-right: 30px;
        }

        ${mq('xl')} {
          margin-right: 60px;
        }

        ${mq('xl')} {
          margin-right: ${getGridSpan('1', 'spread')};
        }
        ${mq('xl')} {
          right: 0;
        }
      }
    `}
`;

export default StyledFullscreenMedia;
